// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M-Cj","label":"styles_label__3q8wX"};